import axios from '../utils/axios';

export default function fetchDiversityPlansList(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/diversity-plans-list', {
            params
        })
    )
}
